import { volumeState } from "../../../recoil/record";
import { useRecoilState } from "recoil";

const VolumeMeter = () => {
  const [volume, setVolume] = useRecoilState(volumeState);

  const threshold = 0.4;

  return (
    <div className="slidecontainer sound">
      <input
        disabled
        type="range"
        min={0}
        max={1000}
        value={volume * 50000}
        className="slider"
      />
      {/* 쓰레스홀드 라인 필요시 */}
      {/* <div
        className="threshold-line"
        style={{ left: `${threshold * 100}%`}} /> */}
    </div>
  );
};
export default VolumeMeter;
